import React from 'react';
import PrenavMenu from '../ui/prenav-menu/PrenavMenu';
import styles from './prenav-link.scss';

const PrenavLink = props => (
  <div
    className={styles.headerLinksContainer}
    data-testid="prenav-redesign-container"
  >
    <button className={styles.headerLinkItem}>{props.children}</button>
    {props.isNewPreNavActive && props.menuLinks.length > 0 && (
      <PrenavMenu {...props} itemClassName={styles.prenavLinkMenuBox} />
    )}
  </div>
);

export default PrenavLink;
